export const MESSAGE_EDIT_AGENDAMENTO_FINALIZADO = "Não é possível realizar edição de um atendimento finalizado, excluir na tecla ao lado e reagendar!";
